"use strict";

import MultiPolygon from "ol/geom/MultiPolygon";

/**
 * @classdesc
 * Wrapperklasse für eine OpenLayers MultiPolygon-Geometrie.
 *
 * @class
 * @extends gc.gis.geom.GCMultiPolygon
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {MultiPolygon} opt_multipolygon gewrappte MultiPolygon-Geometrie-Instanz
 */
gc.gis.geom.OLMultiPolygon = function(opt_multipolygon)
{
    if (!opt_multipolygon)
    {
        opt_multipolygon = new MultiPolygon([]);
    }

    gc.gis.assert.isInstance(opt_multipolygon, MultiPolygon);
    gc.gis.geom.GCMultiPolygon.call(this, opt_multipolygon);

    // mixin erstellen
    const source = gc.gis.geom.OLGeometry.prototype;
    for (let prop in source) {
        if (source.hasOwnProperty(prop)) {
            this[prop] = source[prop];
        }
    }
};
gc.gis.geom.OLMultiPolygon.prototype = Object.create(gc.gis.geom.GCMultiPolygon.prototype);

/**
 * @inheritDoc
 */
gc.gis.geom.OLMultiPolygon.prototype.numPolygons = function()
{
    return this.getImpl().getPolygons().length;
};

/**
 * @inheritDoc
 */
gc.gis.geom.OLMultiPolygon.prototype.getPolygon = function(index)
{
    if (index >= 0 && index < this.numPolygons())
    {
        return new gc.gis.geom.OLPolygon(this.getImpl().getPolygon(index));
    }

    throw new gc.gis.error.GCError('Polygon index [' + index + '] out of bounds.');
};
